import { faCog } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@kcftech/design-system';
import { PhoneNumberInlineEditor } from 'components/inline_edit/PhoneNumberInlineEditor';
import { UserMenuOptions } from 'components/user_menu/UserMenuOptions';
import { IUserContext } from 'contexts/UserContext';
import * as React from 'react';

// TODO: when we get Product Updates url, implement ExternalTextLink component for it.

export type UserMenuProps = Readonly<{
    userContext: IUserContext;
    onSettingsClick: () => void;
    onChangePasswordClick: () => void;
    onPhoneNumberConfirm: (
        phoneNumber: string | undefined
    ) => Promise<string | undefined>;
    phonePopupRef?: React.RefObject<HTMLDivElement>;
}>;

export function UserMenu({
    userContext,
    onSettingsClick,
    onChangePasswordClick,
    onPhoneNumberConfirm,
    phonePopupRef,
}: UserMenuProps) {
    return (
        <>
            <div className="p-20">
                <div className="flex-row">
                    <div className="default bold flex-grow-1">{`${userContext.user?.FirstName} ${userContext.user?.LastName}`}</div>
                    <Button
                        spacing="compact"
                        appearance="subtle"
                        title="Open Profile Settings"
                        ariaLabel="Open Profile Settings"
                        onClick={onSettingsClick}
                    >
                        <FontAwesomeIcon icon={faCog} />
                    </Button>
                </div>
                <div className="mb-10 fine-print">{userContext.user?.Email}</div>
                <div className="f-14 mb-20">
                    <PhoneNumberInlineEditor
                        onConfirm={onPhoneNumberConfirm}
                        value={userContext.user?.PhoneNumber}
                        popupRef={phonePopupRef}
                    />
                </div>
                <UserMenuOptions
                    userContext={userContext}
                    onChangePasswordClick={onChangePasswordClick}
                />
                {/* TODO: Currently we dont have a Product Updates Link, so commenting out for Phase 1.
            <div className="f-14 my-10 mx-0">
                <span onClick={() => alert('Product Updates link not yet implemented.')}>Product Updates</span>
            </div> */}
            </div>
        </>
    );
}
